import { Banner } from '@shopify/polaris';
import { ApiError } from '../api/ApiError';

export interface ErrorBannerProps {
  error: unknown;
  title?: string;
  onDismiss?: () => void;
}

export function ErrorBanner({ error, title, onDismiss }: ErrorBannerProps): JSX.Element {
  let message = 'An unexpected error occurred.';
  if (error instanceof ApiError) {
    message = `${error.status} — ${error.message}`;
  } else if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }
  return (
    <Banner tone="critical" title={title ?? 'Error'} onDismiss={onDismiss}>
      <p>{message}</p>
    </Banner>
  );
}
